<template lang="pug">
  crud-form( v-bind="formPropsApv" @submitForm="submitForm" @reset="reset")
</template>

<script>
import { CrudForm } from '@/components/reusable_components'
import { EmployeeApvFields } from './fields'
import ProviredApvService from '@/services/api/hrProviredApv'
import ProviredApvPaymentTypeService from '@/services/api/hrPreviredApvPaymentType'
import EmployeeService from '@/services/api/employee'
/* vuex */
import { mapState, mapActions } from 'vuex'
export default {
    name: 'employee-apv',
    // props: {},
    data: function() {
        return {
            apvFields: EmployeeApvFields,
        }
    },
    computed: {
        /*
         */
        ...mapState('EmployeeModule', {
            employee: 'employee',
        }),
        /*
         */
        formPropsApv() {
            return {
                editable: this.$can('EDIT_EMPLOYEE'),
                readOnly: !this.$can('EDIT_EMPLOYEE'),
                class: 'elevation-0',
                fields: this.apvFields,
                submitText: 'Guardar',
                //noButtons: true,
                ref: 'form',
            }
        },
    },
    methods: {
        // -- UI Modification
        // -- Data fetching
        // -- Data handling and transformations
        // -- Validations and Error handling
        // -- Other functions
        setApvOptionData: function(index, value) {
            this.apvFields[index].options.data = value
        },
        initEmployeeInfo() {
            //this.employee = await EmployeeService.fetchById( this.$route.params.id )
            this.$nextTick(() => {
                console.log(this.employee)
                this.$refs.form.vmodels.hr_previred_apv_id = this.employee.hr_employee_apv.hr_previred_apv_id
                this.$refs.form.vmodels.hr_previred_apv_payment_type_id = this.employee.hr_employee_apv.hr_previred_apv_payment_type_id
                this.$refs.form.vmodels.contract_number = this.employee.hr_employee_apv.contract_number
                //
                this.$refs.form.vmodels.apv = this.employee.hr_employee_apv.apv
                this.$refs.form.vmodels.apv_afp = this.employee.hr_employee_apv.apv_afp
            })
        },
        /*
         */
        async submitForm(event) {
            let employeeSub = { ...event }
            employeeSub.hr_employee_id = this.employee.id

            let resp = await EmployeeService.updateApv(employeeSub)
            this.resetSnackbarState()

            if (resp.status === 'success') {
                let payload = this.fillSnack(
                    'success',
                    'APV',
                    'Datos guardados exitosamente'
                )
                this.initSnackbar(payload)
                this.$refs.form.editSwitch = false
            } else {
                let payload = this.fillSnack('error', 'Error', response)
                this.initSnackbar(payload)
            }
        },
        reset() {
            this.initEmployeeInfo()
        },
        // -- Vuex mappings
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    // watch: {},
    components: {
        'crud-form': CrudForm,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods

    beforeMount: async function() {
        //let resp = await ProviredApvService.fetchAll()
        this.setApvOptionData(0, await ProviredApvService.fetchAll())
        this.setApvOptionData(1, await ProviredApvPaymentTypeService.fetchAll())
        this.initEmployeeInfo()
        //console.log(resp,'resp')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_EMPLOYEE')) ctx.$router.push('/')
        })
    },
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
</style>